const appConfig = {
  prefix: "mh",
  layout: {
    sideMenu: {
      width: 250,
    },
  },
};


export default appConfig;
